export default __webpack_public_path__ + "static/slider2-0c3c0ca236a964b3ea6952102c7f588a.png";